module.exports = "https://r.nearpod.com/assets/media/image/phet-afbd2b9cae6602a4bdb616cd5c4564a0.svg";